<div class="fullcontainer">
  <br />
  <br />

  <div class='titleContainer'>
    <h2 class='header'>Vehicle Defects</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/workshop/defects/new'><i class="fas fa-plus"></i> New</button>&nbsp;
    </div>
  </div>
  <br />
  <br />
  <app-grid
    entity='workshop-defect'
    [filters]='this.filters'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
  ></app-grid>
</div>
